import axios from "axios";
 const accessTokenTo=sessionStorage.getItem("adminAccToken");
export default axios.create({
  baseURL: process.env.REACT_APP_AWS_API,
  headers: {
    "Content-type": "application/json",
     'Authorization': "Bearer "+accessTokenTo
    //'Authorization': accessTokenTo
  }
});